import React from "react";

function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="75"
      height="30"
      fill="none"
      viewBox="0 0 75 30"
    >
      <path fill="#6E30E9" d="M0 7H4V10H0z"></path>
      <path
        fill="#6E30E9"
        d="M0 10h4v3.25H0V10zM0 13.25h4v3.25H0v-3.25zM0 16.5h4v3.25H0V16.5zM0 19.75h4V23H0v-3.25z"
      ></path>
      <path fill="#6E30E9" d="M4 3H8V7H4z"></path>
      <path fill="#6E30E9" d="M4 23H8V27H4z"></path>
      <path fill="#6E30E9" d="M8 0h4v3H8V0zM8 27h4v3H8v-3z"></path>
      <path fill="#6E30E9" d="M8 3H12V7H8z"></path>
      <path fill="#6E30E9" d="M8 23H12V27H8z"></path>
      <path fill="#6E30E9" d="M8 20H12V23H8z"></path>
      <path fill="#6E30E9" d="M8 17H12V20H8z"></path>
      <path fill="#6E30E9" d="M8 13H12V17H8z"></path>
      <path fill="#6E30E9" d="M8 10H12V13H8z"></path>
      <path fill="#6E30E9" d="M8 7H12V10H8z"></path>
      <path fill="#6E30E9" d="M4 20H8V23H4z"></path>
      <path fill="#6E30E9" d="M4 17H8V20H4z"></path>
      <path fill="#6E30E9" d="M4 13H8V17H4z"></path>
      <path fill="#6E30E9" d="M4 10H8V13H4z"></path>
      <path fill="#6E30E9" d="M4 7H8V10H4z"></path>
      <g filter="url(#filter0_b_3413_4319)">
        <path fill="#6E30E9" d="M0 0H51V30H0z" transform="translate(12)"></path>
        <path
          fill="#fff"
          d="M15.796 19.636V9.296h1.396v10.34h-1.396zM11.32 15.16v-1.388h10.348v1.388H11.32zM36.373 13.148H34.6a2.709 2.709 0 00-1.062-1.733c-.27-.201-.57-.352-.904-.455a3.529 3.529 0 00-1.05-.153c-.671 0-1.272.168-1.802.505-.527.338-.943.832-1.25 1.484-.303.651-.455 1.446-.455 2.386 0 .947.152 1.746.455 2.397.307.652.725 1.145 1.256 1.478.53.333 1.127.5 1.79.5.367 0 .715-.05 1.045-.148.333-.102.634-.252.903-.449a2.718 2.718 0 001.074-1.71l1.773.006a4.745 4.745 0 01-.551 1.58c-.27.477-.616.89-1.04 1.238-.42.345-.902.612-1.443.801a5.337 5.337 0 01-1.773.284c-1.008 0-1.905-.238-2.693-.716-.788-.48-1.41-1.168-1.864-2.062-.45-.894-.676-1.96-.676-3.2 0-1.242.227-2.308.682-3.198.454-.894 1.076-1.58 1.864-2.057.787-.48 1.683-.721 2.687-.721a5.43 5.43 0 011.727.267c.538.174 1.021.431 1.45.772.427.337.781.75 1.062 1.239.28.485.47 1.04.568 1.665zM38.337 21v-8.727h1.642v1.386h.091c.16-.47.44-.839.841-1.108.405-.273.864-.409 1.375-.409a7.236 7.236 0 01.722.04v1.625a3.05 3.05 0 00-.364-.063 3.473 3.473 0 00-.523-.04c-.401 0-.759.086-1.073.256a1.9 1.9 0 00-1.012 1.71V21h-1.699zm6.141 0v-8.727h1.699V21h-1.699zm.858-10.074a1.08 1.08 0 01-.761-.295.96.96 0 01-.313-.716c0-.28.104-.52.313-.716.212-.2.465-.301.76-.301.296 0 .548.1.757.3a.941.941 0 01.318.717.953.953 0 01-.318.716 1.06 1.06 0 01-.756.295zm5.666 10.267a3.564 3.564 0 01-1.5-.307 2.528 2.528 0 01-1.062-.903c-.258-.394-.387-.877-.387-1.449 0-.492.095-.898.284-1.216.19-.318.445-.57.767-.756a4.007 4.007 0 011.08-.42c.398-.095.803-.167 1.216-.216l1.273-.148c.325-.041.562-.107.71-.199.148-.09.221-.238.221-.443v-.04c0-.496-.14-.88-.42-1.153-.277-.272-.69-.409-1.239-.409-.572 0-1.022.127-1.352.38-.326.25-.551.53-.676.836l-1.597-.364c.19-.53.466-.958.83-1.284.367-.33.79-.568 1.267-.716.477-.151.98-.227 1.506-.227.348 0 .717.042 1.108.125.394.08.76.227 1.102.443.344.216.627.525.846.926.22.398.33.915.33 1.551V21h-1.66v-1.193h-.067c-.11.22-.275.435-.495.648-.22.212-.502.388-.846.528-.345.14-.758.21-1.239.21zm.37-1.364c.47 0 .87-.092 1.204-.278a1.95 1.95 0 00.767-.727c.178-.303.267-.627.267-.972v-1.125c-.06.06-.178.118-.352.17-.17.05-.366.094-.585.131-.22.035-.434.067-.642.097-.209.026-.383.05-.523.068-.33.042-.63.112-.904.21-.268.099-.484.24-.647.427-.16.181-.239.424-.239.727 0 .42.155.739.466.954.31.213.706.319 1.187.319zm6.2 1.171v-8.727h1.642v1.386h.09c.16-.47.44-.839.842-1.108.405-.273.863-.409 1.375-.409a7.236 7.236 0 01.721.04v1.625a3.05 3.05 0 00-.363-.063 3.473 3.473 0 00-.523-.04c-.402 0-.76.086-1.074.256a1.9 1.9 0 00-1.011 1.71V21h-1.7z"
        ></path>
      </g>
      <path
        fill="#6E30E9"
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 75 7)"
      ></path>
      <path
        fill="#6E30E9"
        d="M75 10h-4v3.25h4V10zM75 13.25h-4v3.25h4v-3.25zM75 16.5h-4v3.25h4V16.5zM75 19.75h-4V23h4v-3.25z"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 71 3)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 71 23)"
      ></path>
      <path fill="#6E30E9" d="M67 0h-4v3h4V0zM67 27h-4v3h4v-3z"></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 67 3)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 67 23)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 67 20)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 67 17)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 67 13)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 67 10)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 67 7)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 71 20)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 71 17)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 71 13)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 71 10)"
      ></path>
      <path
        fill="#6E30E9"
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 71 7)"
      ></path>
      <defs>
        <filter
          id="filter0_b_3413_4319"
          width="99.681"
          height="78"
          x="-12.681"
          y="-24"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur
            in="BackgroundImageFix"
            stdDeviation="12"
          ></feGaussianBlur>
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_3413_4319"
          ></feComposite>
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3413_4319"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default PlusIcon;
